// extracted by mini-css-extract-plugin
module.exports = {"recommendBox":"Recommend_recommendBox__RtU3J","recommendPop":"Recommend_recommendPop__x7Ohy"};